import React from "react";

import { downloader } from "./service";

export interface IRequiredForDownloader {
  onClick?: (event: React.MouseEvent<any>) => void;
}

export function prepareDownloader<T>(
  getUrl: (props: T) => Promise<string>,
  omitUrlProps: (props: T) => any,
  download = downloader,
) {
  return function <P extends IRequiredForDownloader>(WrappedComponent: React.ComponentType<P>) {
    type Props = P & T;

    return React.memo((props: Props) => {
      const handleClick = async () => {
        const url = await getUrl(props);

        if (url) {
          download(url);
        }
      };

      const componentProps = omitUrlProps(props);
      const { onClick, ...rest } = componentProps;

      return <WrappedComponent onClick={handleClick} {...rest} />;
    });
  };
}
